import { React, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Safety from "../components/SafetyShield";
import ComplianceSection from "../components/ComplianceSection";
import { GiCycle, GiGrassMushroom } from "react-icons/gi";
import "./EngineeringSafety.css";
import p1Image from "../assets/image/E1bg.png";
import p3Image from "../assets/image/E3bg.jpg";
import { MdAccessTime, MdOutlineTouchApp } from "react-icons/md";
import { RiAlarmWarningLine } from "react-icons/ri";
import { TbDeviceHeartMonitor } from "react-icons/tb";
import { LiaHubspot } from "react-icons/lia";
import { FiDatabase } from "react-icons/fi";
import { GiMagicHat, GiTopHat, GiFairyWand, GiCarousel } from "react-icons/gi";
import { motion, AnimatePresence } from "framer-motion";

const hatVariants = {
  magic: {
    rotate: 45,
    opacity: 1,
    transition: { type: "spring", stiffness: 300 },
  },
  top: {
    rotate: -135,
    opacity: 1,
    transition: { type: "spring", stiffness: 300 },
  },
  exit: {
    opacity: 0,
    rotate: 180,
    transition: { duration: 0.3 },
  },
};

function EngineeringSafety() {
  const [isClicked, setIsClicked] = useState(false);
  const togglePanel = () => {
    setIsClicked(!isClicked);
  };
  return (
    <div>
      <Helmet>
        <title>Control, Safety and Information| Riocube Engineering</title>
        <meta
          name="description"
          content="Delivering cutting-edge control, safety, and AI solutions for themed attractions. Ensuring precision, reliability, and compliance for your magical experiences."
        />
        <meta name="keywords" content="" />
      </Helmet>
      <Header />
      <section
        className="hero-banner-e-1"
        style={{ backgroundImage: `url(${p1Image})` }}
      >
        <div className="overlay-e-1">
          <h1>
            CONTROL
            <AnimatePresence mode="wait">
              {isClicked ? (
                <motion.div
                  key="magicHat"
                  variants={hatVariants}
                  initial={{ rotate: -135, opacity: 0 }}
                  animate="magic"
                  exit="exit"
                  style={{
                    display: "inline-block",
                    position: "absolute",
                    top: "-0.1em",
                    right: "-1em",
                    transform: "rotate(45deg)",
                    cursor: "pointer",
                    color: "#FFD700",
                    filter:
                      "drop-shadow(0 0 6px rgba(255,215,0,0.3)) brightness(1.1)",
                    animation: "light-flow 3s ease-in-out infinite",
                  }}
                >
                  <GiMagicHat onClick={togglePanel} />
                </motion.div>
              ) : (
                <motion.div
                  key="topHat"
                  variants={hatVariants}
                  initial={{ rotate: 45, opacity: 0 }}
                  animate="top"
                  exit="exit"
                  style={{
                    display: "inline-block",
                    position: "absolute",
                    top: "-0.2em",
                    right: "-1.1em",
                    transform: "rotate(-135deg)",
                    cursor: "pointer",
                    color: "#FFD700",
                    filter:
                      "drop-shadow(0 0 6px rgba(255,215,0,0.3)) brightness(1.1)",
                    animation: "light-flow 3s ease-in-out infinite",
                  }}
                >
                  <GiTopHat onClick={togglePanel} />
                  <span
                    style={{
                      position: "absolute",
                      bottom: "3em",
                      left: "-1em",
                      transform: "translateX(-50%) rotate(135deg)",
                      fontSize: "0.8rem",
                      color: "#FFD700",
                      opacity: 0.8,
                      fontFamily: "initial",
                      pointerEvents: "none",
                      animation:
                        "light-flow 3s ease-in-out infinite,clickAnimation 3s ease-in-out infinite",
                    }}
                  >
                    CLICK
                  </span>
                </motion.div>
              )}
            </AnimatePresence>
            <GiFairyWand
              className="absolute  transition-all duration-300 ease-out"
              style={{
                position: "absolute",
                top: "-0.5em",
                right: "-1.9em",
                fontSize: "2.6rem",
                color: "#7cf00f",
                opacity: isClicked ? 0 : 1,
                pointerEvents: "none",
                animation:
                  "float 2s ease-in-out infinite, colorChange 3s ease-in-out infinite",
              }}
            />
          </h1>

          <p>
            Design and Implement the Safety Related Control Systems: Show
            Control, Ride Control, Special Effects, Show Action Equipment and
            other subsidiary control systems
          </p>
        </div>
        <AnimatePresence>
          {isClicked && (
            <div
              className="function-grid-top"
              style={{
                transform: "translate(-50%, -50%)",
                width: "1200px",
              }}
            >
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.3 }}
                style={{ position: "static" }}
              >
                <div className="function-grid">
                  <motion.div
                    className="card-column"
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.1 }}
                  >
                    <motion.div
                      className="function-card"
                      initial={{ scale: 0.8 }}
                      animate={{ scale: 1 }}
                      transition={{ type: "spring", stiffness: 200 }}
                    >
                      <MdAccessTime className="card-icon" />
                      <h4>Timecode</h4>
                    </motion.div>
                    <motion.div
                      className="function-card"
                      initial={{ scale: 0.8 }}
                      animate={{ scale: 1 }}
                      transition={{
                        type: "spring",
                        stiffness: 200,
                        delay: 0.15,
                      }}
                    >
                      <h4>Trigger</h4>
                    </motion.div>
                  </motion.div>

                  <motion.div
                    className="card-column"
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.2 }}
                  >
                    <motion.div
                      className="function-card"
                      initial={{ scale: 0.8 }}
                      animate={{ scale: 1 }}
                      transition={{ type: "spring", stiffness: 200 }}
                    >
                      <RiAlarmWarningLine className="card-icon" />
                      <h4>Coordinate</h4>
                    </motion.div>
                    <motion.div
                      className="function-card"
                      initial={{ scale: 0.8 }}
                      animate={{ scale: 1 }}
                      transition={{
                        type: "spring",
                        stiffness: 200,
                        delay: 0.25,
                      }}
                    >
                      <h4>Control Interface</h4>
                    </motion.div>
                  </motion.div>

                  <motion.div
                    className="card-column"
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.3 }}
                  >
                    <motion.div
                      className="function-card"
                      initial={{ scale: 0.8 }}
                      animate={{ scale: 1 }}
                      transition={{ type: "spring", stiffness: 200 }}
                    >
                      <TbDeviceHeartMonitor className="card-icon" />
                      <h4>Real-time monitoring</h4>
                    </motion.div>
                    <motion.div
                      className="function-card"
                      initial={{ scale: 0.8 }}
                      animate={{ scale: 1 }}
                      transition={{
                        type: "spring",
                        stiffness: 200,
                        delay: 0.35,
                      }}
                    >
                      <h4>Safe & Unsafe</h4>
                    </motion.div>
                  </motion.div>

                  <motion.div
                    className="card-column"
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.4 }}
                  >
                    <motion.div
                      className="function-card"
                      initial={{ scale: 0.8 }}
                      animate={{ scale: 1 }}
                      transition={{ type: "spring", stiffness: 200 }}
                    >
                      <MdOutlineTouchApp className="card-icon" />
                      <h4>Human-machine</h4>
                    </motion.div>
                    <motion.div
                      className="function-card"
                      initial={{ scale: 0.8 }}
                      animate={{ scale: 1 }}
                      transition={{
                        type: "spring",
                        stiffness: 200,
                        delay: 0.45,
                      }}
                    >
                      <h4>HMI & Console</h4>
                    </motion.div>
                  </motion.div>

                  <motion.div
                    className="card-column"
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.5 }}
                  >
                    <motion.div
                      className="function-card"
                      initial={{ scale: 0.8 }}
                      animate={{ scale: 1 }}
                      transition={{ type: "spring", stiffness: 200 }}
                    >
                      <LiaHubspot className="card-icon" />
                      <h4>Interface</h4>
                    </motion.div>
                    <motion.div
                      className="function-card"
                      initial={{ scale: 0.8 }}
                      animate={{ scale: 1 }}
                      transition={{
                        type: "spring",
                        stiffness: 200,
                        delay: 0.55,
                      }}
                    >
                      <h4>Facility</h4>
                    </motion.div>
                  </motion.div>

                  <motion.div
                    className="card-column"
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.6 }}
                  >
                    <motion.div
                      className="function-card"
                      initial={{ scale: 0.8 }}
                      animate={{ scale: 1 }}
                      transition={{ type: "spring", stiffness: 200 }}
                    >
                      <FiDatabase className="card-icon" />
                      <h4>Information & Data</h4>
                    </motion.div>
                    <motion.div
                      className="function-card"
                      initial={{ scale: 0.8 }}
                      animate={{ scale: 1 }}
                      transition={{
                        type: "spring",
                        stiffness: 200,
                        delay: 0.65,
                      }}
                    >
                      <h4>Database</h4>
                    </motion.div>
                  </motion.div>
                </div>
                <motion.h2
                  className="grid-title"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.7 }}
                >
                  Ride Show Supervisor System
                </motion.h2>
              </motion.div>
            </div>
          )}
        </AnimatePresence>
      </section>
      <Safety />

      <section
        className="hero-banner-e-3"
        style={{ backgroundImage: `url(${p3Image})` }}
      >
        <div className="overlay-e-3">
          <h1>Information Solutions</h1>
          <p>
            AI driven park wide interactive system Weather monitoring system
          </p>
        </div>
        <div className="monitor-container">
          <div className="right-panel">
            <ul class="monitor-list">
              <li class="monitor-item">
                <div class="monitor-content-wrapper">
                  <p>Environment monitor</p>
                  <div className="icon-container-e">
                    <GiCycle className="grass-icon cycle-animation" />
                    <GiGrassMushroom className="mushroom-icon" />
                  </div>
                </div>
              </li>
              <li class="monitor-item">
                <div class="monitor-content-wrapper">
                  <p>Thunder alert</p>
                  <div className="icon-container-e">
                    <img
                      src={require("../assets/image/E3lightning.png")}
                      alt="闪电警示"
                      className="thunder-image thunder-animation"
                      style={{
                        mixBlendMode: "multiply",
                        filter: "brightness(1.2)",
                      }}
                    />
                  </div>
                </div>
              </li>
              <li class="monitor-item">
                <div class="monitor-content-wrapper">
                  <p>Ride operation status inspection</p>
                  <div className="icon-container-e">
                    <GiCarousel className="coaster-icon coaster-animation" />
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <ComplianceSection />

      <Footer />
    </div>
  );
}
export default EngineeringSafety;
